import { render } from "./CIDStaffWorkload.vue?vue&type=template&id=6dd5c9ac"
import script from "./CIDStaffWorkload.vue?vue&type=script&lang=js"
export * from "./CIDStaffWorkload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__